import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { MiraieService } from './miraie.service';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  year;
  month;
  anchor;

  constructor(
    private http: MiraieService,
    public authService: AuthService,
  ) { }

  //日報取得
  getDailyReport(user_code: number, date) {
    var url = "daily/get";

    let param = { user_code, date }

    return this.http.post(url, param);
  }

  //日報リスト
  getDailyList(year, month) {
    var url = "daily/list";

    let param = { year, month }

    return this.http.post(url, param);
  }


  //週報取得
  getWeeklyReport(user_code, year, month, week) {
    var url = "weekly/get";

    let param = { user_code, year, month, week };
    //console.log(param);
    return this.http.post(url, param);
  }

  //週報リスト
  getWeeklyList(year, month) {
    var url = "weekly/list";

    let param = { year, month }

    return this.http.post(url, param);
  }


  //日報保存
  updateReport(Report) {
    var url = "daily/update";

    return this.http.post(url, Report);
  }

  //週報保存
  updateWeeklyReport(Report) {
    var url = "weekly/update";

    return this.http.post(url, Report);
  }
}
